module.exports = __webpack_public_path__ + "img/medmotion_android_qrcode.6443a51b.png";